// @ts-nocheck
import notesErrorReducer, {
    StoreNotesErrorActions,
} from "@store/Framework/Store/Store/Data/NotesError/NotesErrorReducer";
import { combineReducers } from "redux";

const dataReducers = {
    checkout: notesErrorReducer,
};

export type StoreDataActions = StoreNotesErrorActions;
export default combineReducers(dataReducers);
